import { autoinject } from "aurelia-framework";

import { NoteDataManager } from "../note-data-manager";
import { ToastrService } from "../../../services/toastr-service";

@autoinject
export class CreateInfectionReportBehaviorHandler {
    private _toastrService: ToastrService;

    public constructor(toastrService: ToastrService) {
        this._toastrService = toastrService;
    }

    public handle(noteDataManager: NoteDataManager) {
        try {
            let taskId = noteDataManager.getTaskId();

            if (!!taskId) {
                window.open(`/notes/create-infection-note?associatedTaskId=${taskId}`);
            } else {
                this.displayErrorMessage();
            }
        } catch (e) {
            console.error(e);
            this.displayErrorMessage();
        }
    }

    private displayErrorMessage() {
        this._toastrService.error({
            title: "Create Infection Report - Error",
            message: "There was a problem while creating the infection report. Please try again or report it."
        });
    }
}
